const rankings = [
  { rank: 1, title: '刃牙II：最凶死刑犯篇', heat: '🔥 热读榜第1', desc: '五名死刑犯大战全日本格斗家，系列公认最经典篇章。', tag: '经典必读' },
  { rank: 2, title: '范马刃牙：父子决战篇', heat: '🔥 热读榜第2', desc: '刃牙与勇次郎的终极之战，格斗漫画史上最强对决。', tag: '巅峰之战' },
  { rank: 3, title: '刃牙道：宫本武藏篇', heat: '🔥 热读榜第3', desc: '传奇剑豪在现代复活，跨时代战斗引人入胜。', tag: '剑豪复活' },
  { rank: 4, title: '刃牙道II：相扑道篇', heat: '🔥 热读榜第4', desc: '力士与格斗家碰撞，当前连载中的最新篇章。', tag: '连载中' },
  { rank: 5, title: '刃牙第一部：地下斗技场', heat: '🔥 热读榜第5', desc: '一切故事的起点，地下斗技场铸就热血传奇。', tag: '原作经典' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          刃牙漫画全系列读者热度排行，看看大家都在追哪些篇章
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 font-heading font-bold text-sm ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-primary-400 text-white' :
                item.rank === 3 ? 'bg-accent-500 text-white' :
                'bg-secondary-200 text-secondary-700'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="font-heading text-sm font-bold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-[11px] text-foreground-500">{item.heat}</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
              <span className="px-2 py-1 text-[11px] font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}